import styled from "styled-components";
import { getBreakpoints } from "../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

const CommonFlexStyles = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledInternalNavbar = styled(CommonFlexStyles)`
    position: relative;
    flex-direction: row-reverse;
    justify-content: ${(props) =>
        props.includePrimaryBtn ? "space-between" : "start"};
    width: ${(props) =>
        props.includePrimaryBtn ? "unset" : "100%"};
    

    @media (max-width: ${md}px) {
        // 768px
        flex-direction: column;
        width: 100%;
        justify-content: center;
    }
`;

export const NavWrapper = styled(CommonFlexStyles)`
    margin: 0;
    padding-left: 5vw;
    max-height: 56px;
    width: ${(props) =>
        props.includePrimaryBtn ? "unset" : "100%"};
    justify-content: ${(props) =>
        props.includePrimaryBtn ? "center" : "unset"};

    @media (max-width: ${lg}px) {
        // 768px
        padding-left: 0;
        width: 100%;
    }
`;

export const ListWrapper = styled.ul`
    &&& {
        list-style: none;
        padding-inline-start: 0 !important;
        margin-block-start: 0 !important;
        margin-block-end: 0 !important;
        display: inline-flex !important;
        gap: 4px !important;
        
        @media (max-width: ${lg}px) {
            // 768px
            display: flex !important;
            justify-content: space-evenly !important;
            align-items: center !important;
            width: 100% !important;
        }
    }
`;

export const NavItem = styled.li`
    &&&&&& {
        margin-bottom: 0;
        background-color: ${(props) =>
            props.buttonColor ? props.buttonColor : null} !important;
        color: ${(props) => props.textColor} !important;
        cursor: pointer !important;
        flex-shrink: 0 !important;
        overflow: hidden !important;
        white-space: nowrap !important;
        display: flex !important;
        justify-content: ${(props) => props.justifyContent} !important;
        align-items: ${(props) => props.alignItems} !important;
        padding: 0 10px !important;
        list-style: none !important;
        min-height: 46px !important;
        min-width: 46px !important; //added this so the Specials button doesn't take up more space than other buttons
        border: ${(props) =>
            props.borderColor
                ? `1px solid ${props.borderColor}`
                : null} !important;
        letter-spacing: ${(props) => props.letterSpacing ?? 'unset'};
        text-transform: ${(props) => props.textTransform ?? 'unset'};

        svg {
            fill: ${(props) => props.textColor} !important;
            max-width: unset !important;
        }

        &:hover {
            svg {
                fill: ${(props) => props.hoverTextColor} !important;
            }
            color: ${(props) => props.hoverTextColor} !important;
            background-color: ${(props) =>
                props.hoverButtonColor
                    ? props.hoverButtonColor
                    : null} !important;
        }

        &:focus {
            svg {
                fill: ${(props) => props.hoverTextColor} !important;
            }
            color: ${(props) => props.hoverTextColor} !important;
            background-color: ${(props) =>
                props.hoverButtonColor
                    ? props.hoverButtonColor
                    : null} !important;
        }

        @media (max-width: ${lg}px) {
            // 768px
            flex-direction: column !important;
            padding-bottom: 5px;
        }

        @media (max-width: ${sm}px) {
            // 456px
            font-size: 13px !important;
            flex-shrink: 1 !important;
            margin: 0 !important;
        }
    }
`;

export const NavLink = styled.a`
    &&&&&&& {
        // added 3 ampersands to increase specificity and prevent style sheet override
        text-decoration: none !important;
        color: inherit;
        display: flex !important;
        padding: ${(props) => props.padding} !important;
        justify-content: ${(props) =>
            props.justifyContent ? props.justifyContent : "center"} !important;
        align-items: ${(props) =>
            props.alignItems ? props.alignItems : "center"} !important;
        text-align: center !important;
        white-space: nowrap !important;
        gap: 6px;

        &:hover {
            text-decoration: none !important;
        }
        
        svg {
            max-width: unset !important;
        }

        @media (max-width: ${lg}px) {
            // 768px
            flex-shrink: 1 !important;
            flex-direction: ${(props) => props.flexDirection} !important;
        }

        @media (max-width: ${sm}px) {
            justify-content: center;
        }
    }
`;

export const StyledPrimaryWrapper = styled(CommonFlexStyles)`
    list-style-type: none;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 5vw;
    gap: 6px;
    max-width: 240px;

    @media (max-width: ${md}px) {
        // 768px
        width: 96%;
        max-width: unset;
        padding: 5px 0;
    }
`;

export const PrimaryNavItem = styled(CommonFlexStyles)`
    background-color: ${(props) => props.buttonColor};
    border-radius: ${(props) => props.borderRadius ?? '30px'};
    transition: all 200ms ease-in-out;
    cursor: pointer;
    color: ${(props) => props.textColor};
    border: ${(props) =>
        // extra space is being added when border is applied causing elements to shift so setting this to trasparent prevents the shifting when hovering
        props.borderColor
            ? `1px solid ${props.borderColor}`
            : "1px solid transparent"};
    padding: ${(props) => props.padding};
    min-height: 46px;
    gap: 6px;
    letter-spacing: ${(props) => props.letterSpacing ?? 'unset'};
    text-transform: ${(props) => props.textTransform ?? 'unset'};

    svg {
        fill: ${(props) => props.textColor};
    }

    &:hover {
        svg {
            fill: ${(props) => props.hoverTextColor};
        }
        color: ${(props) => props.hoverTextColor};
        background-color: ${(props) => props.hoverButtonColor};
        border: ${(props) =>
            props.hoverTextColor
                ? `1px solid ${props.hoverTextColor}`
                : "1px solid transparent"};
    }

    @media (max-width: ${lg}px) {
        // 768px
        width: 100%;
        font-size: 16px;
    }

    @media screen and (max-width: ${sm}px) {
        min-height: unset;
    }
`;

export const StyledDropdownWrapper = styled.div`
    max-width: 200px;
    position: absolute;
    top: 100%;
    left: 4vw;
    z-index: 100000;

    @media (max-width: ${lg}px) {
        // 768px
        left: 0;
    }
`;

export const DropdownList = styled.ul`
    &&& {
        margin-block-start: 0 !important;
        margin-block-end: 0 !important;
        padding-inline-start: 0 !important;
    }
`;

export const StyledAnchor = styled(NavLink).attrs({
    as: "a",
})`
    &&& {
        gap: ${(props) => (props.linksListLength > 1 ? "6px" : null)};
        display: ${(props) => (props.linksListLength <= 1 ? null : "flex")};
        justify-content: ${(props) =>
            props.linksListLength <= 1 ? null : "center"};
        align-items: ${(props) =>
            props.linksListLength <= 1 ? null : "baseline"};
        padding-left: 5px;

        @media (max-width: ${lg}px) {
            padding-left: 0;
        }
    }

    @media (max-width: ${lg}px) {
        // 768px
        flex-shrink: 1 !important;
        flex-direction: ${(props) => props.flexDirection} !important;
    }

    @media (max-width: ${sm}px) {
        justify-content: center;
    }
`;
